<!-- Loading spinner -->
<qai-inner-wrap *ngIf="isLoading && isTranslationLoaded" class="loading-container">
  <qai-loading
    [label]="'personalizedPractice.LOADING' | transloco"
    [size]="'medium'"
  ></qai-loading>
</qai-inner-wrap>

<qai-inner-wrap *ngIf="!isLoading">
  <section class="personalized-practice-sessions">
    <!-- Header section with title and filters -->
    <div class="title">
      <!-- Title with session count -->
      <div class="sub-title column">
        {{ "reportingV2.SESSIONS" | transloco }}
        <div class="sessions">
          {{ filteredSessions.length }}
          <span>{{ "personalizedPractice.TOTAL" | transloco }}</span>
        </div>
      </div>

      <!-- Filter controls -->
      <div *ngIf="sessions.length > 0" class="filters">
        {{ "personalizedPractice.FILTERS" | transloco }}

        <!-- Learner filter -->
        <qai-floating-select
          [placeholder]="'personalizedPractice.LEARNER' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [options]="learnerOptions"
          [value]="learnerSelectedValue"
          (valueChange)="onLearnerChange($event)"
        ></qai-floating-select>

        <!-- Date filter -->
        <qai-datepicker-material
          [disabled]="false"
          [placeholder]="'personalizedPractice.DATE' | transloco"
          [value]="selectedDate"
          [kind]="'secondary'"
          [shape]="'rectangle'"
          [size]="'medium'"
          [endIcon]="'chevron-down'"
          [weight]="'regular'"
          [locale]="currentLocale"
          (valueChange)="onDateChange($event)"
        ></qai-datepicker-material>

        <!-- Conversation type filter -->
        <qai-floating-select
          class="select-large"
          [placeholder]="'personalizedPractice.CONVERSATION_TYPE' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [options]="conversationTypeOptions"
          [value]="conversationTypeSelectedValue"
          (valueChange)="onConversationTypeChange($event)"
        ></qai-floating-select>

        <!-- Difficulty filter -->
        <qai-floating-select
          [placeholder]="'personalizedPractice.DIFFICULTY' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [options]="difficultyTypeOptions"
          [value]="difficultyTypeSelectedValue"
          (valueChange)="onDifficultyChange($event)"
        ></qai-floating-select>

        <!-- Mood filter -->
        <qai-floating-select
          [placeholder]="'personalizedPractice.MOOD' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [options]="moodOptions"
          [value]="moodSelectedValue"
          (valueChange)="onMoodChange($event)"
        ></qai-floating-select>

        <button qai-link class="clear-filters" (click)="onClearFilters($event)">
          {{ "personalizedPractice.CLEAR_FILTERS" | transloco }}
        </button>
      </div>
    </div>

    <!-- Chart -->
    <app-personalized-practice-sessions-chart
      *ngIf="areFiltersApplied && filteredSessions.length > 0"
      [data]="filteredSessions"
    ></app-personalized-practice-sessions-chart>

    <qai-table
      [headers]="headers"
      [data]="filteredTableRows"
      [striped]="false"
      [pageSize]="10"
      [currentPage]="1"
      [showPagination]="true"
      [clickableHeader]="true"
      [noDataMessage]="'personalizedPractice.NO_SESSIONS_FOUND' | transloco"
      [initialSortColumn]="initialSortColumn"
      [initialSortDirection]="initialSortDirection"
      [previousLabel]="'personalizedPractice.PAGINATION_PREVIOUS' | transloco"
      [nextLabel]="'personalizedPractice.PAGINATION_NEXT' | transloco"
    ></qai-table>
  </section>
</qai-inner-wrap>
